export default __webpack_public_path__ + "static/media/zuliebe.5169b70d.webp";